var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[("button-" + _vm.size), ("button-" + (_vm.isSecondary ? 'secondary' : 'primary')),
    { 'disabled-style': _vm.hasDisabledStyle },
    { 'warning': _vm.isWarning },
    { 'error': _vm.isError }],attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('clicked', $event)}}},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }